import SettingBase from '../settings/util/SettingBase'

class CarrierController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'carrier'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-carrier']) {
      this.hasACL[this.acl['setting-carrier'][key]] = true;
    }
  }
}
export default CarrierController;


// WEBPACK FOOTER //
// ./client/app/components/carrier/carrier.controller.js